export default "__VITE_ASSET__cc0fc576__"